export const getAvatarColor = (fullName: string) => {
  if (!fullName || !fullName.trim())
    return '#' + (0x5000000).toString(16).slice(1)
  const hashCode = fullName.split('').reduce((hash, char) => {
    return char.charCodeAt(0) + ((hash << 5) - hash)
  }, 0)

  return '#' + ((hashCode & 0x00ffffff) | 0x5000000).toString(16).slice(1)
}

export const getEmptyAvatar = (fullName: string): string => {
  if (!fullName || !fullName.trim()) return ''

  const [firstName, lastName] = fullName.trim().split(/\s+/)
  const firstInitial = firstName[0]
  const secondInitial = lastName ? lastName[0] : ''

  return `${firstInitial}${secondInitial}`
}
